module.exports = __webpack_public_path__ + "static/media/points-portal1.115181bd.115181bd.JPG";